export const apiUrl = "https://qa-sfm-admin-api.mytvsuper.com";
export const mytvsuperUrl = "https://qa-www.mytvsuper.com";

// Enable after the mpm-rows-order-by-platform API is deployed to the target environment.
export const enableMpmPlatformOrdering = true;

//Push Notification Role Ids (Comma Separateed String)
// export const pnEditorRoleIds = "63759cac04e7f697394a78b1,60c8672f08d5c271c567052b,64950afda29efe9bc76cc2b5";
// export const pnApproverRoleIds = "651526fe6b3be48e707b5620,60c8672f08d5c271c567052b,64950afda29efe9bc76cc2b5";
// export const pnMocRoleIds = "6246bb9d86f7c200188f3aa0,60c8672f08d5c271c567052b,64950afda29efe9bc76cc2b5";
